<template>
  <div class="part_resume_dialog">
    <custom-dialog :visible="visible" width="1200px" :title="model.title" v-on="$listeners">
      <div class="dialog-body">
        <h1 class="item-title">{{ $t('asm_part_resume_dialog.she_bei_xin_xi') }}</h1>
        <div class="item-title-info">
          <el-row>
            <el-col :span="8">
              <span class="label">{{ $t('asm_part_resume_dialog.chan_pin_xing_hao') }}</span>
              <span class="value">{{ info.productCode || '-' }}</span>
            </el-col>
            <el-col :span="8">
              <span class="label">{{ $t('asm_part_resume_dialog.ji_shen_hao') }}:</span>
              <span class="value">{{ info.bodyNum || '-' }}</span>
            </el-col>
            <el-col :span="8">
              <span class="label">Modem SN:</span>
              <span class="value">{{ info.modemSn || '-' }}</span>
            </el-col>
            <el-col :span="8">
              <span class="label">{{ $t('asm_part_resume_dialog.chu_chang_ri_qi') }}:</span>
              <span class="value">{{ info.productionTime || '-' }}</span>
            </el-col>
            <el-col :span="8">
              <span class="label">{{ $t('asm_part_resume_dialog.dian_chi_rong_liang') }}:</span>
              <span class="value">{{ info.fullChargeCapacity || '-' }} AH</span>
            </el-col>
            <el-col :span="8">
              <span class="label">{{ $t('asm_part_resume_dialog.cfdxhcs') }}:</span>
              <span class="value">{{ info.batteryCycleCount || '-' }}</span>
            </el-col>
          </el-row>
        </div>
        <h1 class="item-title" v-if="info.structureList">{{ $t('asm_part_resume_dialog.bu_jian_shou_ming') }}</h1>
        <ul class="part-box" v-if="info.structureList">
          <li
            class="part-item component-detail"
            v-for="(item, j) in info.structureList"
            :key="j"
            :class="{
              warning: isWarning(item)
            }"
          >
            <div class="component-name">{{ item.componentName || '-' }}</div>
            <div class="device-status">
              {{
                !item.currentVal? $t('asm_part_resume_dialog.wu') : item.currentVal + item.currentUnit
              }}
            </div>
            <div
              class="process-content"
              v-if="item.currentVal && item.maxVal"
            >
              <div class="process">
                <div
                  class="process-bar"
                  :style="getProcessStyle(item)"
                  :class="{'normal-val':item.currentVal/item.criticalVal<1,'beyond-val':item.currentVal/item.maxVal>1,'warn-val':item.currentVal/item.criticalVal>1}"
                ></div>
              </div>
              <div
                class="critical-val"
                :class="{'beyond-val':item.currentVal/item.maxVal>1}"
                :style="getCriticalValStyle(item)"
              ></div>
            </div>

          </li>
        </ul>
        <h1 class="item-title">{{ $t('asm_part_resume_dialog.ljghmx') }}</h1>
        <div class="table-dialog-bd">
          <custom-table-expand
            ref="customTb1"
            index
            :rowId="getRowKeys"
            :data="tableList"
            :column="tableColumn"
            @sort="sortChange"
            @filter="filterChange"
            @exChange="exChange"
            expand-row-keys
            expand
            :slots="['expand']"
          >
            <template slot="expand" slot-scope="scope">
              <div class="part-pic ub" v-if="scope.row.beforeFileList && scope.row.beforeFileList.length && scope.row.afterFileList && scope.row.afterFileList.length">
                <div style="margin-right: 60px" v-if="scope.row.beforeFileList && scope.row.beforeFileList.length">
                  <h1>{{ $t('asm_part_resume_dialog.ljghq') }}</h1>
                  <ul class="ubw">
                    <li v-for="(item, index) in scope.row.beforeFileList" :key="index">
                      <img @click="onViewImage(item.attachPath)" :src="item.attachPath" alt />
                    </li>
                  </ul>
                </div>
                <div v-if="scope.row.afterFileList && scope.row.afterFileList.length">
                  <h1>{{ $t('asm_part_resume_dialog.ljghh') }}</h1>
                  <ul class="ubw">
                    <li v-for="(item, index) in scope.row.afterFileList" :key="index">
                      <img @click="onViewImage(item.attachPath)"  :src="item.attachPath" alt />
                    </li>
                  </ul>
                </div>
              </div>
              <empty-tips v-else></empty-tips>
            </template>
          </custom-table-expand>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
        <el-button size="small" type="primary">{{ $t('Common.com_export') }}({{ $t('asm_part_resume_dialog.zan_wu') }})</el-button>
        <el-button size="small" type="primary">{{ $t('asm_part_resume_dialog.da_yin') }}({{ $t('asm_part_resume_dialog.zan_wu') }})</el-button>
      </div>
      <!-- 查看地图图片 -->
      <el-image-viewer v-if="dialogVisibleImage" class="img"  :url-list="[dialogImageUrl]"  :on-close="()=>dialogVisibleImage=false" ></el-image-viewer>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';
import customTableExpand from '@/components/customTableExpand.vue';

export default {
  mixins: [dialogMixins],
  components: {
    customTableExpand,
  },
  data() {
    return {
      tableCode: 'part_resume_detail',
      // 获取row的key值
      getRowKeys(row) {
        return row.orderPartId;
      },
      info: {},
      bodyNum: '',
      beforeFileList: [],
      afterFileList: [],
      tableList: [],
      totalRows: null,

      dialogVisible: false,
      dialogModel: {},
      dialogVisibleImage: false,
      dialogImageUrl: '',
    };
  },
  mounted() {
    this.initDialog();
    this.getTableColumn();
  },

  methods: {
    getProcess(val1, val2) {
      return (val1 / val2) * 100;
    },
    getProcessStyle(item) {
      return {
        width: `${this.getProcess(item.currentVal, item.maxVal)}%`,
      };
    },
    getCriticalValStyle(item) {
      return {
        left: `${this.getProcess(item.criticalVal, item.maxVal)}%`
      };
    },
    // showIcon(item) {
    //   // 部件寿命不展示icon
    //   return (
    //     item.isMalfunction || this.isWarning(item)
    //   );
    // },
    isWarning(item) {
      return (
        item.currentVal && item.criticalVal && item.currentVal > item.criticalVal
      );
    },


    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
      if (this.model.type === 'detail') {
        this.bodyNum = this.model.row.bodyNum;
        // this.bodyNum = '20200509006';
        this.getTableList();
        this.getResumeInfo();
      }
    },
    getResumeInfo: function () {
      this.$getJSON(apis.DeviceResumeBizInfo, {
        bodyNum: this.bodyNum,
      }).then((res) => {
        this.info = res.data;
      });
    },
    // 获取表格数据列表
    getTableList: function () {
      this.$getJSON(apis.workOrderPartListForDevice, {
        bodyNum: this.bodyNum,
      }).then((res) => {
        this.tableList = res.data || [];
      });
    },

    exChange: function (row) {
      this.getAttachList(row);
    },
    // 查看图片
    onViewImage: function (url) {
      this.dialogVisibleImage = true;
      this.dialogImageUrl = url;
    },
    // 获取零件变更图片
    getAttachList: async function (item) {
      if (!item.orderPartId) {
        return;
      }
      await Promise.all([this.$getJSON(`${apis.OssAttach}/${item.orderPartId}/asm.service.part.old`), this.$getJSON(`${apis.OssAttach}/${item.orderPartId}/asm.service.part.new`)]).then(([beforeFileList, afterFileList]) => {
        beforeFileList.data.map(f => this.getAttachUrl(f));
        afterFileList.data.map(f => this.getAttachUrl(f));
        this.$set(item, 'beforeFileList', beforeFileList.data);
        this.$set(item, 'afterFileList', afterFileList.data);
      });
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },

    changePayer: function (item) {
      this.dialogModel.type = 'edit';
      this.dialogModel.title = this.$t('asm_part_resume_dialog.xiu_gai_fu_kuan_fang');
      this.dialogModel.row = item;
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="scss">
.part_resume_dialog {
  .part-box {
    padding-bottom: 16px;
    display: flex;
    flex-flow: row wrap;
    .part-item {
      width: 208px;
      height: 100px;
      background: #f8f9fb;
      border-radius: 2px;
       border: 1px solid #f2f3fb;
      padding: 2px 14px 8px;
      margin: 10px 10px 0 0;
      .part-content {
        display: flex;
        .title {
          .key {
            font-size: 12px;
            font-weight: bold;
            color: #495057;
            line-height: 36px;
          }
          .val {
            height: 32px;
            font-size: 20px;
            color: #394668;
            line-height: 32px;
            margin-top: -7px;
          }
        }
        i {
          margin-left: auto;
          font-size: 40px;
          &.error {
            color: #ff5c5b;
          }
          &.warning {
            color: #f9c851;
          }
        }
      }
      .process {
        position: relative;
        height: 3px;
        width: 100%;
        background: #f0f2f5;
        border-radius: 2px;
        overflow: hidden;
        margin: 6px 0 8px;
        .process-bar {
          position: absolute;
          height: 100%;
          background: #0d9ae0;
          border-radius: 1px;
        }
        .caveat-val {
          background: #0d9ae0 !important;
        }
        .warn-val {
          background: #f36704 !important;
        }
        .beyond-val {
          background-color: #ff0100 !important;
        }
      }

      .life {
        height: 20px;
        font-size: 12px;
        color: #98a6ad;
        line-height: 20px;
      }


      &.warning {
        .process-bar {
          // background: #f36704 !important;
        }
        .critical-val {
          background: #f36704;
        }
        .beyond-val {
          background-color: #ff0100 !important;
        }
      }


        &:hover {
          // cursor: pointer;
          border-color: rgba(13, 154, 224, 0.3);
          background-color: #fff;
        }
        .component-name {
          $h: 18px;
          height: $h;
          line-height: $h;
          font-size: 12px;
          font-weight: bold;
          color: #495057;
        }
        // .using-time {
        //   $h: 24px;
        //   color: #394668;
        //   font-weight: bold;
        //   font-size: 20px;
        //   line-height: $h;
        //   height: $h;
        // }
        .process-content {
          overflow: hidden;
          position: relative;
          padding-bottom: 2px;
        }
        .process {
          position: relative;
          height: 2px;
          width: 100%;
          background: #f0f2f5;
          border-radius: 1px;
          overflow: hidden;
          margin-top: 4px;
          .process-bar {
            position: absolute;
            height: 100%;
            background: #0d9ae0;
            border-radius: 1px;
          }
          .caveat-val {
            background: #0d9ae0 !important;
          }
          .warn-val {
            background: #f36704 !important;
          }
          .beyond-val {
            background-color: #ff0100 !important;
          }
        }
        .critical-val {
          width: 2px;
          height: 4px;
          position: absolute;
          top: 3px;
          background: #f36704;
          transform: translateX(-1px);
        }
        .beyond-val {
          background-color: #ff0100 !important;
        }
        .service-life {
          color: #98a6ad;
          font-size: 12px;
          line-height: 20px;
          margin-top: 8px;
          float: left;
        }
        &:hover {
          .detail {
            opacity: 1;
          }
        }
        .detail {
          color: #35b8e0;
          font-size: 12px;
          float: right;
          line-height: 20px;
          position: absolute;
          right: 14px;
          bottom: 8px;
          opacity: 0;
          transition: all 0.3s;
          &:hover {
            cursor: pointer;
          }
        }
        .icon-content {
          width: 24px;
          height: 24px;
          position: absolute;
          right: 10px;
          top: 10px;
          .icon {
            font-size: 24px;
          }

          > img {
            max-width: 100%;
            max-height: 100%;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            position: absolute;
            margin: auto;
          }
        }

        .device-status {
          color: #6c757d;
          font-size: 12px;
          margin-top: 12px;
          line-height: 18px;
        }
        .device-time {
          color: #98a6ad;
          line-height: 12px;
          height: 12px;
          margin-top: 10px;
          font-size: 12px;
        }
        .date {
          color: #98a6ad;
          font-size: 12px;
          margin-top: 16px;
        }

    }
  }
  .part-pic {
    padding: 16px;
    h1 {
      font-weight: bold;
      line-height: 17px;
      margin-bottom: 10px;

      font-size: 12px;
      color: #495057;
      line-height: 17px;
    }
    ul li img {
      width: 60px;
      height: 60px;
      border-radius: 2px;
      // border: 1px solid rgba(238, 238, 238, 1);
      margin-right: 16px;
    }
  }
}
</style>
